import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  user = null
  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
      _id: ['']
    })

    var user  = sessionStorage.getItem('userId');

    this.http.get<any>(this.api_endpoint+'/memberregbyid/' + user).subscribe(
      data => {
        this.user = data.data;
        this.Form.patchValue({
          _id: data.data._id,
          lastName: data.data.lastName,
          firstName: data.data.firstName,
          email: data.data.email,
          password: data.data.password,
          
        });

    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });

   }

   onFormSubmit() {
    this.http.put<any>(this.api_endpoint+'/memberreg/', this.Form.value).subscribe(
      res => {
        // console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Updated';
          this.class = 'btn btn-success';
        } 
        this.ngOnInit
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
   }

}
